import PropTypes from 'prop-types';
import { css, cx } from '@eti/styles';
import { ProductCard, ProductCardBlock, ProductCardList } from '../../product-card';
import { SERVICE_PACKAGE } from '../../products';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = css`
  display: flex;
`;
const cardStyles = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`;
const listStyles = css`
  margin-top: auto;
`;
const radioStyles = css`
  margin: 1.5rem 0 0.5rem;
  pointer-events: none;
  position: relative;

  &:hover {
    cursor: pointer;
  }

  &::after {
    border-radius: 50%;
    content: '';
    display: none;
    inset: 2px 2px 3px;
    position: absolute;
    vertical-align: baseline;
  }

  .ServicePackage-item:hover &:not(:checked)::after {
    background-color: #d9d9d9;
    display: inline-block;
  }
`;
const ServicePackageRadio = _ref => {
  let {
    isChecked
  } = _ref;
  return /*#__PURE__*/_jsx("input", {
    checked: isChecked,
    className: radioStyles,
    name: "servicePackage",
    readOnly: true,
    type: "radio"
  });
};
ServicePackageRadio.propTypes = {
  isChecked: PropTypes.bool
};
const handleChange = (item, onChange) => e => {
  e.preventDefault();
  if (onChange) {
    onChange(item, e);
  }
};
const ServicePackage = _ref2 => {
  let {
    className,
    header,
    items = [],
    onChange
  } = _ref2;
  return /*#__PURE__*/_jsxs("form", {
    className: cx('ServicePackage', className, styles),
    children: [header && /*#__PURE__*/_jsxs(ProductCard, {
      className: cx('ServicePackage-header ServicePackage-item', cardStyles),
      hasBorder: false,
      children: [/*#__PURE__*/_jsx(ProductCardBlock, {
        subTitle: header.subTitle,
        title: header.title
      }), /*#__PURE__*/_jsx(ProductCardList, {
        className: listStyles,
        items: header.items
      })]
    }), items.length > 0 && items.map(item => /*#__PURE__*/_jsxs(ProductCard, {
      className: cx('ServicePackage-item', cardStyles),
      "data-offer-rate": SERVICE_PACKAGE.id,
      isActive: item.active,
      isInteractive: true,
      isSuccess: item.popular,
      onClick: handleChange(item, onChange),
      children: [/*#__PURE__*/_jsx(ProductCardBlock, {
        shouldCenter: true,
        subTitle: item.subTitle,
        title: item.title,
        children: /*#__PURE__*/_jsx(ServicePackageRadio, {
          checked: item.active,
          value: item.value
        })
      }), /*#__PURE__*/_jsx(ProductCardList, {
        className: listStyles,
        isSuccess: item.popular,
        items: item.items,
        shouldCenter: true
      })]
    }, item.title))]
  });
};
ServicePackage.propTypes = {
  className: PropTypes.string,
  header: PropTypes.objectOf(PropTypes.any),
  items: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func
};
export default ServicePackage;